import React, { useState } from 'react';
import './UserTable.css';

function UserTable({ users, onCreate, onEdit, onDelete }) {
  const [showModal, setShowModal] = useState(false);
  const [modalUser, setModalUser] = useState(null);
  const [form, setForm] = useState({ email: '', password: '', role: 'user' });

  const openCreateModal = () => {
    setModalUser(null);
    setForm({ email: '', password: '', role: 'user' });
    setShowModal(true);
  };

  const openEditModal = (user) => {
    setModalUser(user);
    setForm({ email: user.email, password: '', role: user.role });
    setShowModal(true);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (modalUser) {
      onEdit({ ...modalUser, ...form });
    } else {
      onCreate(form);
    }
    setShowModal(false);
  };

  return (
    <div className="user-table-section">
      <div className="user-table-header">
        <h3>Usuários Logados</h3>
        <button onClick={openCreateModal}>Novo Usuário</button>
      </div>
      <table className="user-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Role</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.email}</td>
              <td>{user.role}</td>
              <td>
                <button onClick={() => openEditModal(user)}>Editar</button>
                <button className="danger" onClick={() => onDelete(user.id)}>Excluir</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h4>{modalUser ? 'Editar Usuário' : 'Novo Usuário'}</h4>
            <form onSubmit={handleSubmit}>
              <input
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
                required
                autoComplete="username"
              />
              <input
                name="password"
                type="password"
                placeholder="Senha"
                value={form.password}
                onChange={handleChange}
                required={!modalUser}
                autoComplete="new-password"
              />
              <select name="role" value={form.role} onChange={handleChange}>
                <option value="user">Usuário</option>
                <option value="admin">Admin</option>
              </select>
              <div className="modal-actions">
                <button type="submit">Salvar</button>
                <button type="button" className="secondary" onClick={() => setShowModal(false)}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserTable;
